import React, { useState, useEffect, useContext } from 'react';
import styles from './OglasExpanded.module.css';
import { parseTimestamp } from '../util/TimestampParser';
import Breadcrumb from './Breadcrumb';
import { OGLASNE_PLOCE, BASE_URL_OGLASI, BASE_URL_PRILOG_DOWNLOAD } from '../util/constants';
import { ThemeContext } from '../contexts/ThemeContext';
import { ReactComponent as FileAttachment } from '../assets/file-attachment.svg';

const OglasExpanded = (props) => {
  const [breadcrumbPath, setBreadcrumbPath] = useState(['Početna', 'Oglasi']);

  const [oglas, setOglas] = useState();
  const { dark } = useContext(ThemeContext);

  useEffect(() => {
    fetch(BASE_URL_OGLASI + props.match.params.godinaId)
      .then(response => response.json())
      .then(oglasi => oglasi.find(oglas => oglas.id === parseInt(props.match.params.oglasId)))
      .then(oglas => {
        setOglas(oglas);
        setBreadcrumbPath(b =>
          [...b, 
            OGLASNE_PLOCE.find(ploca => ploca['id'] === parseInt(props.match.params.godinaId))['naziv'],
            oglas.naslov + ( oglas.uvod != null && oglas.uvod.trim() !== "" ? " - " + oglas.uvod : "")]
          );
      })
      .catch(function (err) {
        console.log('Fetch Error :', err);
      });
  }, [props.match.params.godinaId, props.match.params.oglasId]);

  return (
    <>
      {oglas === undefined || oglas === null ? (
        // {/*<div className={styles.emptyListContainer}>Nepostojeci oglas.</div>*/}
        null
      ) : (
          <>
            <Breadcrumb
              path={breadcrumbPath} />
            <div className={styles.oglasExpandedContent}>
              <div className={styles.oglas}>
                <div className={styles.oglasHeader}>
                  <div className={styles.oglasHeading}>
                    {oglas.naslov}{oglas.uvod != null && oglas.uvod.trim() !== "" ? " - " + oglas.uvod : ""}
                  </div>
                  <div className={styles.oglasTimestamp}>{parseTimestamp(oglas.vrijemeKreiranja).join(' ')}</div>
                </div>
                <div className={styles.oglasBody}>{oglas.sadrzaj.trim()}</div>
                <div className={styles.oglasAttachments}>
                  {oglas.oglasPrilozi.map(prilog => {
                    return (
                      <div
                        key={prilog.id}
                        className={dark ? styles.oglasPrilogDark : styles.oglasPrilogLight}>
                          <a 
                            target='_blank' 
                            rel="noopener noreferrer" 
                            href={BASE_URL_PRILOG_DOWNLOAD + oglas.id + '/download'}>
                              <FileAttachment className={dark ? styles.fileAttachmentDark : styles.fileAttachmentLight} />
                              {prilog.originalniNaziv}
                          </a>
                      </div>
                    );
                  })}
                </div>
                <div className={dark ? styles.oglasSignatureDark : styles.oglasSignatureLight }>{oglas.potpis}</div>
              </div>
            </div>
          </>
        )}

    </>
  );
}

export default OglasExpanded;